<script>
import { defineComponent, ref } from '@vue/composition-api'
import { WarningServiceProxy } from '@/service-proxies/app-v2/tpm.service-proxies'
import useModal from '@/hooks/useModal'
import TodayCheck from './TodayCheck/TodayCheck'
import RepairApply from './RepairApply/RepairApply'
import RepairRecord from './RepairRecord/RepairRecord'
import OverduePlan from './OverduePlan/OverduePlan'
import ConfirmedPlan from './ConfirmedPlan/ConfirmedPlan'
import WarningPlan from './WarningPlan/WarningPlan'
import TodayPlan from './TodayPlan/TodayPlan'

const wsp = new WarningServiceProxy()

export default defineComponent({
  components: {
    TodayCheck,
    OverduePlan,
    ConfirmedPlan,
    WarningPlan,
    TodayPlan,
    RepairApply,
    RepairRecord,
  },
  setup(_, { root }) {
    const list = ref([
      {
        title: 'page_tpm_warning_maintance_overdue_jian' || '保养计划超期',
        subTitle:
          'page_tpm_warning_maintance_overdue_sub' ||
          '原定的保养日期已过，仍然处于待执行状态的保养计划，当前日期大于保养日期',
        count: 0,
        to: '/tpm/maintain-plans',
      },
      {
        title: 'page_tpm_warning_maintance_today_jian' || '今日保养计划',
        subTitle: 'page_tpm_warning_maintance_today_sub' || '处于“待执行”且未超期的保养计划，“执行中”状态的保养计划',
        count: 0,
        to: '/tpm/maintain-plans',
      },
      {
        title: 'page_tpm_warning_maintance_plan_jian' || '保养计划预警',
        subTitle: 'page_tpm_warning_maintance_plan_sub' || '按照预警周期，显示所有设备处于预警期内的保养计划',
        count: 0,
        to: '/tpm/maintain-plans',
      },
      {
        title: 'page_tpm_warning_repair_today_jian' || '今日维修申请',
        subTitle: 'page_tpm_warning_repair_today_sub' || '处于“待执行”和“执行中”状态的维修申请',
        count: 0,
        to: '/tpm/repair-apply',
      },
      {
        title: 'page_tpm_warning_check_today_jian' || '今日点检执行',
        subTitle: 'page_tpm_warning_check_today_sub' || '所有设备在今日已经执行的点击记录明细表',
        count: 0,
        to: '/tpm/check-record',
      },
      {
        title: 'page_tpm_warning_maintance_confirm_jian' || '保养待确认',
        subTitle: 'page_tpm_warning_maintance_confirm_sub' || '状态为待确认的保养记录',
        count: 0,
        to: '/tpm/maintain-records',
      },
      {
        title: 'page_tpm_warning_repair_confirm_jian' || '维修待确认',
        subTitle: 'page_tpm_warning_repari_confirm_sub' || '状态为待确认的维修记录',
        count: 0,
        to: '/tpm/repair-record',
      },
    ])
    function readCounts() {
      wsp.maintainStatisticsNum().then(res => {
        list.value[0].count = res.delayNum
        list.value[1].count = res.todayNum
        list.value[2].count = res.warningNum
        list.value[5].count = res.recordNum
      })
      wsp.getApplyCount().then(res => (list.value[3].count = res))
      wsp.checkRecordStatisticsNum().then(res => (list.value[4].count = res))
      wsp.getRecordCount().then(res => (list.value[6].count = res))
    }

    const { modalAttrs, modalEvents } = useModal()
    const current = ref()
    function openModal(index) {
      current.value = list.value[index]

      modalAttrs.title = root.$t(list.value[index].title)
      modalAttrs.visible = true
      modalAttrs.width = window.screen.width - 160 
    }
    function closeModal() {
      readCounts()
      modalAttrs.visible = false
    }

    function jumpToDetail() {
      if (current.value?.to) root.$router.push(current.value.to)
    }

    // init
    readCounts()

    return {
      list,

      modalAttrs,
      modalEvents,
      current,
      openModal,
      closeModal,
      jumpToDetail,
    }
  },
})
</script>

<template>
  <div style="background: #fff;">
    <template v-for="(item, index) in list">
      <div
        class="d-flex hover-blue px-8"
        style="align-items: center; cursor: pointer; height: 100px; border-bottom: 1px solid #eee;"
        :key="'p-' + item.title"
        @click="openModal(index)"
      >
        <span style="font-size: 20px; width: 140px;">{{ $t(item.title) }}</span>
        <span style="width: 50px; text-align: center;"><a-badge :count="item.count"></a-badge></span>
        <span style="padding-left: 24px; color: #ccc;">{{ $t(item.subTitle) }}</span>
        <a-icon style="margin-left: auto;" type="right" />
      </div>
    </template>
    <a-modal v-bind="modalAttrs" v-on="modalEvents">
      <!-- 不同的组件 -->
      <OverduePlan v-if="list[0] === current" />
      <TodayPlan v-if="list[1] === current" />
      <WarningPlan v-if="list[2] === current" />
      <RepairApply v-if="list[3] === current" />
      <TodayCheck v-if="list[4] === current" />
      <ConfirmedPlan v-if="list[5] === current" />
      <RepairRecord v-if="list[6] === current" />

      <template #footer>
        <a-button @click="jumpToDetail">{{ $t('page_device_all_type' || '全部') }}</a-button>
        <a-button @click="closeModal">{{ $t('close' || '关闭') }}</a-button>
      </template>
    </a-modal>
  </div>
</template>

<style scoped lang="less">
.hover-blue {
  transition: all 0.3s;
  &:hover {
    background: #e6f7ff;
  }
}
</style>
